import { render, staticRenderFns } from "./CreatorJoin.vue?vue&type=template&id=0ed748d5&scoped=true&"
import script from "./CreatorJoin.vue?vue&type=script&lang=js&"
export * from "./CreatorJoin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ed748d5",
  null
  
)

export default component.exports